
import type { IconProps } from 'src/types/icons';

const CloseIcon = (props: IconProps) => (
  <svg {...props} width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.25293 1L9.13909 8.88616" stroke="#FF5D5D" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1.25293 8.88616L9.13909 1" stroke="#FF5D5D" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export default CloseIcon;
